module.exports = __webpack_public_path__ + "images/file_icons_v2/sys-76a179db94ff4de5d307b283522fabe3.svg";